import * as React from 'react';
import { Skeleton } from '@cian/ui-kit';

export const RecommendationSkeleton: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--unit_2)' }}>
      <Skeleton width="100%" height={'auto'} style={{ aspectRatio: '164 / 90' }} />
      <Skeleton width="100%" height={56} />
    </div>
  );
};
